import $ from 'jquery';
import Handlebars from 'handlebars/dist/handlebars';
import Bloodhound from 'corejs-typeahead/dist/bloodhound';
import 'corejs-typeahead/dist/typeahead.jquery';

$(async () => {
  const $element = $('.js-typeahead');

  if (!$element.length) {
    return;
  }

  await initialise($element);
});

/** Initialise typeahead. */
async function initialise($element) {
  // Get Bloodhound source.
  const source = await getBloodhoundSource('value');

  // Initialise settings.
  const settings = {
    hint: true,
    highlight: true,
    minLength: 3,
  };

  // Initialise dataset.
  const dataset = {
    displayKey: 'value',
    name: 'main-search',
    source: source.ttAdapter(),
    templates: {
      // eslint-disable-next-line max-len
      suggestion: Handlebars.compile(
        // eslint-disable-next-line max-len
        '<div><span class="tt-type">{{resultType}}</span>{{value}} <br><span class="tt-area">{{content}}</span></div>',
      ),
    },
  };

  // Initialise typeahead.
  $element.typeahead(settings, dataset).on('typeahead:select', onSelect);
}

/** Handle select event. */
function onSelect($event, suggestion) {
  if (!suggestion.url) {
    return;
  }

  window.location.href = suggestion.url;
}

/** Get initialised Bloodhound instance. */
function getBloodhoundSource(valueKey) {
  // Create Bloodhound instance.
  const source = new Bloodhound({
    // defer initialization
    initialize: false,

    // define how to identify a unique item
    identify: datum => datum.id,

    // define how to sort results
    sorter: (a, b) => {
      if (a.score < b.score) {
        return -1;
      }
      if (a.score > b.score) {
        return 1;
      }
      return 0;
    },

    // assign tokenizers
    datumTokenizer: Bloodhound.tokenizers.obj.nonword(valueKey),
    queryTokenizer: Bloodhound.tokenizers.nonword,

    // define how to prefetch results
    prefetch: {
      url: '/api/search/prefetch',
      ttl: 3600000, // 1 hour
      transform: items => (!items ? [] : items.map(item => item.suggestion)),
    },
  });

  // Initialise source.
  return source.initialize().then(() => source);
}
